import { CONSULTANT_CLOSE, CONSULTANT_OPEN } from '../../reducers/consultant'

export const openConsultant = () => ({
  type: CONSULTANT_OPEN,
})

export const closeConsultant = () => ({
  type: CONSULTANT_CLOSE,
})
